module.exports = __webpack_public_path__ + "img/6.70b73eb8.jpg";